(function () {
  ('use strict');

  const peerSupportComponent = document.querySelectorAll('#peerSupportMeta');

  function formatDate(date) {
    return date.toISOString().split('T')[0];
  }
  // eslint-disable-next-line
  peerSupportComponent.forEach((component) => {
    const peerSupportStartDateString = document.querySelector('meta[name="peerSupportStartDate"]').getAttribute('content');
    const peerSupportEndDateString = document.querySelector('meta[name="peerSupportEndDate"]').getAttribute('content');
    const joinSessionBtn = document.getElementById('joinSessionBtn');

    // Adjust date creation to consider local timezone
    const peerSupportStartDate = new Date(peerSupportStartDateString + 'Z'); // Appending 'Z' to indicate UTC
    const peerSupportEndDate = new Date(peerSupportEndDateString + 'Z');

    const formattedStartDate = formatDate(peerSupportStartDate);
    const formattedEndDate = formatDate(peerSupportEndDate);
    const formattedCurrentDate = formatDate(new Date());

    //Show joinSessionBtn if is between startDate and endDate
    if (joinSessionBtn) {
      if (formattedStartDate <= formattedCurrentDate && formattedEndDate >= formattedCurrentDate) {
        joinSessionBtn.classList.remove('hide');
      } else {
        joinSessionBtn.classList.add('hide');
      }
    }

    // const mentorSection = component.querySelector('#sectionMentor');
    // const menteeSection = component.querySelector('#sectionMentee');
    // const mentorButton = component.querySelector('#sectionMentorButton');
    // const menteeButton = component.querySelector('#sectionMenteeButton');

    // const toggleSections = (showSection) => {
    //   mentorSection.classList.toggle('hidden', !showSection);
    //   menteeSection.classList.toggle('hidden', showSection);
    // };

    // mentorButton.addEventListener('click', () => {
    //   toggleSections(true);
    // });

    // menteeButton.addEventListener('click', () => {
    //   toggleSections(false);
    // });
  });
})();
